'use strict';
const angular = require('angular');

export default angular.module('conduuApp.weather', [])
  .directive('weather', function($timeout) {
    return {
      template: '<div id="weather"></div></div>',
      restrict: 'EA',
      scope: {
        location: "@",
        unit: "@"
      },
      link: function (scope, element, attrs) {

        var unit = scope.unit || "f";

        $timeout(function () {

          $(document).ready(function () {

            let currentWeather = "",
            forecast = "";

            $.simplerWeather( {
              location: scope.location,
              units: 'f',
              authmethod: 'proxy',
              proxyurl: '/api/integrations/weather',
              success: function( weather ) {
                currentWeather = '<h2> <i class="icon ' + weather.icon + '"></i> ' +
                  Math.round( weather.temp ) + '&deg;' + weather.unit.toUpperCase() + "</h2>";

                currentWeather += '<p>' + weather.currently + '</p>';

                $( "#weather" ).html( currentWeather );

                //return forcast to unordered list.
                /*
                forecast = '<div class="row">';

                // the first value in the array is the current date so set i to 1 to get future weather
                for( var i = 1; i < 4; i++ ) {
                  forecast += '<div class="col-xs-4 text-center"><h3>'+Math.round( weather.forecast[ i ].temperatureMax ) + '&deg;' + weather.unit.toUpperCase()+'</h3><i class="icon ' + weather.forecast[ i ].icon +
                    '"></i><br/><small>';
                  forecast += weather.forecast[ i ].summary + '</small></div>';
                }

                forecast += '</div>';

                $( "#forecast" ).html( forecast );*/
              },
              error: function( error ) {
                $( "#weather" ).html( '<p>' + error + '</p>' );
              }
            } ); //end main weather display

            /*
            $.simpleWeather({
              location: scope.location,
              woeid: '',
              unit: unit,
              success: function (weather) {
                var html = '<h2><i class="icon-' + weather.code + '"></i> ' + weather.temp + '&deg;' + weather.units.temp + '</h2>'
                  + weather.currently + ' &middot; ' + weather.wind.direction + ' ' + weather.wind.speed + ' ' + weather.units.speed;

                $("#weather").html(html);
              },
              error: function (error) {
                $("#weather").html('No data available!');
              }
            });
            */

          });

        });

      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/weather/weather.directive.js